import ReactDOM from 'react-dom/client';
import { HashRouter } from 'react-router-dom';
import { ThemeProvider as MaterialThemeProvider } from '@material-tailwind/react';
import App from './App';
import { Auth0ProviderWithNavigate } from './auth0-provider-with-navigate';
import { ThemeProvider } from './context/themeContext';
import { LangProvider } from './context/langContext';
import { ToastProvider } from './context/toastContext';
import { UserContextProvider } from './context/userContext';
import './index.css';

const root = ReactDOM.createRoot(document.getElementById('root')!);
root.render(
    <ThemeProvider>
        <LangProvider>
            <MaterialThemeProvider>
                <HashRouter>
                    <Auth0ProviderWithNavigate>
                        <ToastProvider>
                            <UserContextProvider>
                                <App />
                            </UserContextProvider>
                        </ToastProvider>
                    </Auth0ProviderWithNavigate>
                </HashRouter>
            </MaterialThemeProvider>
        </LangProvider>
    </ThemeProvider>,
);
